"use client";

import { useUser as useUserContext } from '@/context/UserContext';

export function useCustomer() {
  const { user, ...rest } = useUserContext();
  return { user, ...rest };
}

export function useWaiter() {
  const { user, ...rest } = useUserContext();
  return { user, ...rest };
}

export function useAdmin() {
  const { user, ...rest } = useUserContext();
  return { user, ...rest };
}

export function useOwner() {
  const { user, ...rest } = useUserContext();
  return { user, ...rest };
}

export function useVendor() {
  const { user, ...rest } = useUserContext();
  return { user, ...rest };
}

export function useUser() {
  return useUserContext();
}
